module.exports = __webpack_public_path__ + "static/media/about-us.334e140a.png";